import ProtectedPage from "../../../common/ProtectedPage";
import ClientHeader from "../../../common/ClientHeader";
import LoadingSpinner from "../../../common/Loading";
import { useState, useEffect } from "react";
import CommandsQueries from "../../../../requests/queries/CommandsQueries";
import './CommandsPageStyles.css';
import { convertStatusToEnglish } from "../../../../utils/utils";

export default function CommandsPage({ currentCommand, setCurrentCommand }) {

    const [commands, setCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        CommandsQueries.findAllByClientPaid().then((res) => {
            setCommands(res.data.commands);
            setIsLoading(false);
        }).catch((err) => {
            setError(err.response?.data?.message || 'An error occurred');
            setIsLoading(false);
        });
    }, []);

    if(isLoading) {
        return <LoadingSpinner />;
    }

    if(error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    return (
        <ProtectedPage needToBeAuthenticated={false} redirectPath="/client-auth">
            <ClientHeader displayCart={false} currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
            <div className="commands-page-container">
                <h1>My Orders</h1>
                {commands && commands.length > 0 ? (
                    <div className="commands-list">
                        {commands.map((command) => (
                            <div className="command-card" key={command.id}>
                                <h2>Order #{command.number}</h2>
                                <div className="command-info">
                                    <div className="command-info-item">
                                        <span className="command-info-label">Status</span>
                                        <span className={`status-badge ${command.status?.toLowerCase() || 'pending'}`}>
                                            {convertStatusToEnglish(command.status)}
                                        </span>
                                    </div>
                                    <div className="command-info-item">
                                        <span className="command-info-label">Date</span>
                                        <span className="command-info-value">
                                            {new Date(command.updated_at || command.created_at).toLocaleDateString('en-GB', { 
                                                day: '2-digit', 
                                                month: 'long', 
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })}
                                        </span>
                                    </div>
                                    <div className="command-info-item">
                                        <span className="command-info-label">Products</span>
                                        <span className="command-info-value">
                                            {command.products?.length || 0} item{command.products?.length !== 1 ? 's' : ''}
                                        </span>
                                    </div>
                                </div>
                                
                                {command?.products && command.products.length > 0 && (
                                    <>
                                        <h3 className="command-products-title">Items</h3>
                                        <div className="command-products">
                                            {command.products.map((product) => {
                                                return (
                                                    <div className="command-product" key={product.id}>
                                                        <img src={product?.images?.[0]?.image_url || 'https://via.placeholder.com/300x300?text=Image'} alt={product.name} />
                                                        <p className="command-product-name">{product.name}</p>
                                                        {product.quantity > 0 && (
                                                            <p className="command-product-detail">
                                                                <strong>Quantity:</strong> {product.quantity}
                                                            </p>
                                                        )}
                                                        <p className="command-product-detail">
                                                            {product.color && <strong>Color:</strong>} {product.color}
                                                        </p>
                                                        <p className="command-product-detail">
                                                            {product.size && <strong> Size:</strong>} {product.size}
                                                        </p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <div className="empty-state-icon">📦</div>
                        <p className="empty-state-text">No orders found</p>
                        <p className="empty-state-subtext">Your paid orders will appear here</p>
                    </div>
                )}
            </div>
        </ProtectedPage>
    );
}